module.exports = __webpack_public_path__ + "img/bandeira-inglaterra.d08960ae.svg";